import { render, staticRenderFns } from "./reportsview.vue?vue&type=template&id=a97fc506"
import script from "./reportsview.vue?vue&type=script&lang=js"
export * from "./reportsview.vue?vue&type=script&lang=js"
import style0 from "./reportsview.vue?vue&type=style&index=0&id=a97fc506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports